import cx from 'classnames';
import type { FC, ReactNode } from 'react';

import { Button } from '@zen/DesignSystem';
import type { ButtonType, ButtonVariant } from '@zen/DesignSystem/types';
import type { IconName } from '@zen/Styleguide';
import type { ButtonClick } from '@zen/types';

import type { FormButtonsLayout } from './types';

interface Props {
  children?: ReactNode;
  className?: string;
  containerClassName?: string;
  iconLeft?: IconName;
  isDisabled?: boolean;
  isSubmitting: boolean;
  layout?: FormButtonsLayout;
  onClick?: (e: ButtonClick) => void;
  size?: 'default' | 'compact';
  text?: string;
  type?: ButtonType;
  variant?: ButtonVariant;
}

const FormButtons: FC<Props> = (props) => {
  const {
    children = null,
    className = '',
    containerClassName,
    iconLeft,
    isDisabled = false,
    isSubmitting,
    layout = 'static',
    onClick = undefined,
    size,
    text = 'Submit',
    type = 'submit',
    variant = 'primary'
  } = props;

  const containerClassNames: string = cx(
    {
      'my-6': !containerClassName && layout !== 'fixed',
      'fixed bottom-0 left-0 right-0 rounded-b bg-white flex-row-reverse space-x-reverse border-t border-solid border-grey-lighter py-4 px-6':
        layout === 'fixed'
    },
    'flex space-x-4 mx-0',
    containerClassName
  );

  return (
    <div className={containerClassNames} data-testid="form-buttons">
      <Button
        className={className}
        data-testid="submit-button"
        disabled={isSubmitting || isDisabled}
        iconLeft={iconLeft}
        isLoading={isSubmitting}
        onClick={onClick}
        size={size}
        type={type}
        variant={variant}
      >
        {text}
      </Button>
      {children}
    </div>
  );
};

export default FormButtons;
